export default "__VITE_ASSET__1$3dEfjP__"